import React from 'react';

// Colors for the cameras pages. Video reads best on a dark ground, so these
// pages are dark in both app themes (as they always were).
export const C = {
  bg: '#0e1012',
  bar: '#121417',
  surface: '#15181b',
  raised: '#1b1f23',
  track: '#1d2125',
  border: '#262b31',
  borderStrong: '#2f353c',
  text: '#e9ecef',
  textSoft: '#c3cad2',
  muted: '#a1a9b3',
  faint: '#8a929c',
  live: '#3ccf7a',
  work: '#5aa2ff',
  workBlock: '#2f6fd0',
  maintBlock: '#b7791f',
  recorded: '#4a525c',
  warn: '#f0a030',
  bad: '#ff6b6b',
  focus: '#8cbcff',
  selected: '#132338',
};

// Hover / focus / responsive rules can't live in inline styles. Everything is
// prefixed jqc- so nothing leaks into the rest of JobQ.
const CSS = `
.jqc-root{min-height:100vh;background:${C.bg};color:${C.text};font-size:14px;line-height:1.4;font-variant-numeric:tabular-nums}
.jqc-root *{box-sizing:border-box}
.jqc-btn{display:inline-flex;align-items:center;gap:7px;min-height:38px;padding:0 13px;border-radius:8px;border:1px solid ${C.borderStrong};background:${C.raised};color:${C.text};font:inherit;font-size:13px;font-weight:500;cursor:pointer;text-decoration:none;white-space:nowrap}
.jqc-btn:hover{background:#252a31;color:#fff}
.jqc-btn:disabled{opacity:.4;cursor:default}
.jqc-icon{width:38px;padding:0;justify-content:center}
.jqc-seg{display:inline-flex;padding:3px;gap:2px;border-radius:10px;background:${C.raised};border:1px solid #2a2f35}
.jqc-seg button{display:inline-flex;align-items:center;min-height:32px;padding:0 13px;border-radius:7px;border:0;background:transparent;color:${C.muted};font:inherit;font-size:13px;font-weight:500;cursor:pointer;white-space:nowrap}
.jqc-seg button:hover{color:#fff}
.jqc-seg button[aria-pressed="true"]{background:#2c3138;color:#fff}
.jqc-chip{display:inline-flex;align-items:center;gap:6px;min-height:36px;padding:0 13px;border-radius:999px;border:1px solid #2a2f35;background:transparent;color:${C.textSoft};font:inherit;font-size:13px;cursor:pointer;white-space:nowrap}
.jqc-chip:hover{border-color:#454c55;color:#fff}
.jqc-chip[aria-pressed="true"]{background:${C.text};border-color:${C.text};color:${C.bg};font-weight:600}
.jqc-btn:focus-visible,.jqc-chip:focus-visible,.jqc-seg button:focus-visible,.jqc-tile:focus-visible,.jqc-mini:focus-visible,.jqc-thumb:focus-visible,.jqc-row:focus-visible,.jqc-nav:focus-visible,.jqc-day:focus-visible{outline:2px solid ${C.focus};outline-offset:2px}
.jqc-grid{display:grid;gap:14px;grid-template-columns:repeat(auto-fill,minmax(min(100%,var(--jqc-min,420px)),1fr))}
.jqc-tile{display:flex;flex-direction:column;padding:0;border:1px solid ${C.border};border-radius:12px;overflow:hidden;background:${C.surface};color:inherit;text-align:left;font:inherit;cursor:pointer;min-width:0}
.jqc-tile:hover{border-color:#414852}
.jqc-wide{grid-column:span 2}
@media (max-width:820px){.jqc-wide{grid-column:auto}}
.jqc-frame{position:relative;display:block;width:100%;background:#000;overflow:hidden}
.jqc-frame>img,.jqc-frame>video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block}
.jqc-frame>.jqc-contain{object-fit:contain}
.jqc-r-std{aspect-ratio:7/4}
.jqc-r-wide{aspect-ratio:7/2}
@media (max-width:820px){.jqc-r-wide{aspect-ratio:1536/432}}
.jqc-mini{display:flex;align-items:center;gap:12px;padding:6px;border:1px solid #22272d;border-radius:10px;background:${C.surface};color:inherit;text-align:left;font:inherit;cursor:pointer;min-width:0;width:100%}
.jqc-mini:hover{border-color:#414852}
.jqc-nav{position:absolute;top:50%;margin-top:-22px;width:44px;height:44px;border-radius:50%;border:0;background:rgba(10,12,14,.72);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:2}
.jqc-nav:hover{background:rgba(10,12,14,.92)}
.jqc-thumb{display:flex;flex-direction:column;gap:5px;padding:3px;border:1px solid transparent;border-radius:9px;background:transparent;color:${C.muted};font:inherit;font-size:11px;cursor:pointer;min-width:0}
.jqc-thumb:hover{color:#fff;border-color:${C.borderStrong}}
.jqc-thumb[aria-current="true"]{border-color:${C.focus};background:${C.selected};color:#fff}
.jqc-row{display:flex;align-items:flex-start;gap:10px;width:100%;padding:8px 10px;border:0;border-radius:8px;background:transparent;color:inherit;text-align:left;font:inherit;cursor:pointer}
.jqc-row:hover{background:${C.raised}}
.jqc-row[aria-current="true"]{background:${C.selected}}
.jqc-ell{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0}
.jqc-dot{width:8px;height:8px;border-radius:50%;flex:none;display:inline-block}
.jqc-card{background:${C.surface};border:1px solid ${C.border};border-radius:12px}
.jqc-day{cursor:pointer;touch-action:none}
.jqc-blk{position:absolute;top:0;bottom:0;display:flex;align-items:center;padding-left:4px;overflow:hidden;color:#fff;font-size:11px;white-space:nowrap}
.jqc-pop{position:absolute;right:0;top:calc(100% + 6px);z-index:50;width:min(420px,90vw);background:${C.surface};border:1px solid ${C.borderStrong};border-radius:12px;padding:12px;box-shadow:0 12px 32px rgba(0,0,0,.5)}
.jqc-root input[type=date]{color-scheme:dark}
`;

export default function CamerasStyles() {
  return <style>{CSS}</style>;
}

// Small inline icons (stroke, currentColor) so the pages don't depend on
// which Font Awesome glyphs happen to be loaded.
const PATHS = {
  back: <><path d="M19 12H5" /><path d="M12 19l-7-7 7-7" /></>,
  left: <path d="M15 18l-6-6 6-6" />,
  right: <path d="M9 18l6-6-6-6" />,
  rewind: <><path d="M3 12a9 9 0 1 0 3-6.7" /><path d="M3 4v5h5" /></>,
  forward: <><path d="M21 12a9 9 0 1 1-3-6.7" /><path d="M21 4v5h-5" /></>,
  expand: <><path d="M8 3H5a2 2 0 0 0-2 2v3" /><path d="M21 8V5a2 2 0 0 0-2-2h-3" /><path d="M3 16v3a2 2 0 0 0 2 2h3" /><path d="M16 21h3a2 2 0 0 0 2-2v-3" /></>,
  download: <><path d="M12 3v12" /><path d="M7 10l5 5 5-5" /><path d="M5 21h14" /></>,
  link: <><path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" /><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" /></>,
  calendar: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M16 3v4M8 3v4M3 10h18" /></>,
  camera: <><path d="M15 10l4.6-2.3a1 1 0 0 1 1.4.9v6.8a1 1 0 0 1-1.4.9L15 14" /><rect x="3" y="6" width="12" height="12" rx="2" /></>,
  grid: <><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></>,
};

export function Icon({ name, size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {PATHS[name]}
    </svg>
  );
}

export function PlayPauseIcon({ playing, size = 18 }) {
  return playing ? (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></svg>
  ) : (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 5v14l12-7z" /></svg>
  );
}

export const KIND_DOT = {
  working: C.work,
  paused: C.warn,
  maintenance: C.maintBlock,
  waiting: '#5f6771',
  idle: '#5f6771',
};
